import { createContext } from 'react';
import type { JobsState, JobsActions } from '../types';

/**
 * Context for read-only job state.
 * Following Kent C. Dodds' pattern, separating state from actions
 * prevents unnecessary re-renders when components only need actions.
 */
export const JobsStateContext = createContext<JobsState | undefined>(undefined);

/**
 * Context for job action functions.
 * Following Kent C. Dodds' pattern, these functions are stabilized
 * with useCallback to prevent re-renders.
 */
export const JobsDispatchContext = createContext<JobsActions | undefined>(undefined);
